import { baseResources, baseResourceActions } from "routes/enum";

const {
    KB_KNOWLEDGE_BASE,
    KB_PRODUCT_SETTING,
    KB_CAPSULE,
    KB_CONTENT_BLOCK,
    KB_SAM_COLLECTION,
} = baseResources;

const { READ, CREATE, UPDATE, DELETE } = baseResourceActions;

/** View knowledge base */
export const KNOWLEDGE_BASE_READ_PERMISSION = [`${READ}_${KB_KNOWLEDGE_BASE}`];

/** Add new products */
export const PRODUCT_CREATE_PERMISSION = [`${CREATE}_${KB_PRODUCT_SETTING}`];

/** Add new capsule (of any type) */
export const CAPSULE_CREATE_PERMISSION = [`${CREATE}_${KB_CAPSULE}`];

/** Delete capsule */
export const CAPSULE_DELETE_PERMISSION = [`${DELETE}_${KB_CAPSULE}`];

/** Edit capsule */
export const CAPSULE_UPDATE_PERMISSION = [`${UPDATE}_${KB_CAPSULE}`];

/** Edit content block */
export const CONTENT_BLOCK_UPDATE_PERMISSION = [`${UPDATE}_${KB_CONTENT_BLOCK}`];

/** Add new content block */
export const CONTENT_BLOCK_CREATE_PERMISSION = [`${CREATE}_${KB_CONTENT_BLOCK}`];

/** Add new solution collection */
export const SOLUTION_COLLECTION_CREATE_PERMISSION = [
    `${CREATE}_${KB_SAM_COLLECTION}`,
];

export const CAPSULE_WRITE_PERMISSION = [
    ...CAPSULE_CREATE_PERMISSION,
    ...CAPSULE_UPDATE_PERMISSION,
];

export const KNOWLEDGE_BASE_PERMISSION_MAP = {
    "View knowledge base": KNOWLEDGE_BASE_READ_PERMISSION,
    "Add new products": PRODUCT_CREATE_PERMISSION,
    "Add new capsule (of any type)": CAPSULE_CREATE_PERMISSION,
    "Delete capsule": CAPSULE_DELETE_PERMISSION,
    "Edit capsule": CAPSULE_UPDATE_PERMISSION,
    "Edit content block": CONTENT_BLOCK_UPDATE_PERMISSION,
    "Add new content block": CONTENT_BLOCK_CREATE_PERMISSION,
    "Add new solution collection": SOLUTION_COLLECTION_CREATE_PERMISSION,
};
